import React from 'react';
import {Trans} from '@lingui/react';
import VisuallyHidden from '@reach/visually-hidden';

import iconify from '../iconify';

const CloseIcon = ({customColor, ...props}) => (
  <>
    <VisuallyHidden>
      <Trans id="privacy.close">Close Icon</Trans>
    </VisuallyHidden>
    <svg width="1em" height="1em" viewBox="0 0 41 41" {...props}>
      <g
        fill="none"
        stroke={customColor ? 'currentColor' : 'url(#linear-gradient)'}
        strokeWidth={6}
        strokeMiterlimit={10}
      >
        <path d="M2.1 2.1l36.8 36.8" />
        <path d="M38.9 2.1L2.1 38.9" />
      </g>
    </svg>
  </>
);

export default iconify(CloseIcon);
